<template>
  <a-form
    ref="formState"
    :model="formState"
    :rules="rules"
    v-bind="{
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
    }"
  >
    <a-form-item label="编号" name="pass">
      <a-input v-model:value="formState.num" type="text" />
    </a-form-item>

    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="$confirm(contract,formState)">确认</a-button>
      <a-button style="margin-left: 10px" @click="reset">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  data() {
    return {
      contract: null,
      defaultData: {},
      formState: {
        num: "",
        creator: "",
        remark: "",
        userId: "",
      },
    };
  },
  async mounted() {
    let id = this.$route.query.id;
    if (id) {
      this.contract = await new this.$lc.Query("contract")
        .equalTo("objectId", id)
        .first();
      this.formState = { ...this.contract.attributes };
      this.defaultData = { ...this.contract.attributes };
    } else {
      this.contract = new this.$lc.Object("contract");
      let userId = await new this.$lc.User.current().get("objectId");
      this.formState.userId = userId;
    }
  },
  methods: {
    // 重置
    reset() {
      this.formState = { ...this.defaultData };
    },
  },
};
</script>